import { getLeagueLogoUrl } from '../../urls';
import { LEAGUE_NAMES, type ESPNLeagueId } from '../../../shared';
import { LIGHT, bbox, leagueBuilder, team } from '../builders';
import type { LogoVsLogoLeague } from '../types';

const ID: ESPNLeagueId = 'premier-league';
const { variant, uniform, visitorOnly, localOnly } = leagueBuilder(ID);

const teams = [
  team('arsenal', 'Arsenal', [variant('#FF0001', 'arsenal'), visitorOnly('#003176', 'arsenal')]),
  team('aston-villa', 'Aston Villa', [variant('#7FBFE6', 'aston-villa'), visitorOnly('#69022A', 'aston-villa')]),
  team('bournemouth', 'Bournemouth', [variant('#C8090E', 'bournemouth'), visitorOnly('#FFFFFF', 'bournemouth')]),
  team('brentford', 'Brentford', [variant('#E20000', 'brentford'), visitorOnly('#FEFEFE', 'brentford')]),
  team('brighton', 'Brighton', [variant('#0059B2', 'brighton'), visitorOnly('#DDDDDD', 'brighton')]),
  team('chelsea', 'Chelsea', [variant('#143988', 'chelsea'), visitorOnly('#FFFFFF', 'chelsea')]),
  team('coventry-city', 'Coventry City', [
    variant('#269CD5', 'coventry-city'),
    visitorOnly('#D2050D', 'coventry-city')
  ]),
  team('crystal-palace', 'Crystal Palace', [
    variant('#071B6C', 'crystal-palace'),
    visitorOnly('#CA1027', 'crystal-palace')
  ]),
  team('everton', 'Everton', uniform('everton', '#014593', LIGHT)),
  team('fulham', 'Fulham', [variant('#000000', 'fulham'), visitorOnly('#FF1414', 'fulham')]),
  team('hull-city', 'Hull City', [variant('#FF8B00', 'hull-city'), visitorOnly('#DDDDDD', 'hull-city')]),
  team('ipswich-town', 'Ipswich Town', uniform('ipswich-town', '#243998', LIGHT)),
  team('leeds', 'Leeds', uniform('leeds', '#FFE100', LIGHT)),
  team('liverpool', 'Liverpool', [localOnly('#FF010D', 'liverpool'), variant(LIGHT, 'liverpool')]),
  team('manchester-city', 'Manchester City', uniform('manchester-city', '#83C2E9', '#061A3B')),
  team('manchester-united', 'Manchester United', uniform('manchester-united', '#DA0812', '#FFD700')),
  team('newcastle', 'Newcastle', [variant('#000000', 'newcastle'), visitorOnly('#FFFFFF', 'newcastle')]),
  team('nottingham-forest', 'Nottingham Forest', [
    localOnly('#DC0000', 'nottingham-forest'),
    variant(LIGHT, 'nottingham-forest')
  ]),
  team('sunderland', 'Sunderland', uniform('sunderland', '#FF001B', LIGHT)),
  team('tottenham', 'Tottenham', [localOnly('#00023A', 'tottenham'), variant('#DDDDDD', 'tottenham')]),
  // Equipos históricos que no juegan esta temporada — se mantienen por si se usan manualmente.
  team('leicester', 'Leicester City', uniform('leicester', '#003F9E', '#DDDDDD')),
  team('southampton', 'Southampton', uniform('southampton', '#D10A11', LIGHT)),
  team('west-ham', 'West Ham', uniform('west-ham', '#8B1F3E', '#88DEF6')),
  team('wolverhampton', 'Wolverhampton', uniform('wolverhampton', '#FAB900', LIGHT))
];

export const premierLeague: LogoVsLogoLeague = {
  value: ID,
  label: LEAGUE_NAMES[ID],
  logo: { src: getLeagueLogoUrl(ID), bbox: bbox(35, 44, 322, 381) },
  teams
};
